import { createStyles, makeStyles } from "@material-ui/core";
import { UIKIT_COLORS } from "../../ui-kit/theme/colors";

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "block",
      width: "100%",
      "& > * + *": { marginTop: 12 },
    },
    label: {
      display: "block",
      fontSize: 12,
      fontWeight: 500,
      color: UIKIT_COLORS.TEXT_MUTED,
      letterSpacing: "0.3px",
      textTransform: "uppercase",
      lineHeight: "16px",
    },
    docRow: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      backgroundColor: UIKIT_COLORS.BG_LIGHT,
      border: `1px solid ${UIKIT_COLORS.BORDER}`,
      borderRadius: 8,
      padding: 13,
      boxSizing: "border-box",
    },
    thumbnailWrapper: {
      position: "relative",
      width: 80,
      height: 48,
      flexShrink: 0,
      border: `1px solid ${UIKIT_COLORS.BORDER_DARK}`,
      borderRadius: 4,
      overflow: "hidden",
    },
    viewedBadge: {
      position: "absolute",
      top: 4,
      right: 4,
      width: 16,
      height: 16,
      borderRadius: "50%",
      backgroundColor: UIKIT_COLORS.SUCCESS,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& .MuiSvgIcon-root": { fontSize: 10, color: UIKIT_COLORS.WHITE },
    },
    thumbnail: {
      width: "100%",
      height: "100%",
      background: "linear-gradient(135deg, #c7d2fe 0%, #ddd6fe 30%, #bfdbfe 60%, #d1fae5 100%)",
      filter: "blur(4px)",
      transform: "scale(1.15)",
    },
    docName: {
      flex: "1 1 auto",
      minWidth: 0,
      fontSize: 14,
      fontWeight: 600,
      color: UIKIT_COLORS.TEXT_PRIMARY,
      lineHeight: "20px",
      marginLeft: 16,
    },
    imageCount: {
      marginLeft: 8,
      fontSize: 11,
      fontWeight: 500,
      color: UIKIT_COLORS.TEXT_SECONDARY,
    },
    actions: {
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
      marginLeft: 16,
      "& > * + *": { marginLeft: 16 },
    },
    viewBtn: {
      border: `1.5px solid ${UIKIT_COLORS.PRIMARY} !important`,
      borderRadius: 8,
      padding: "3px 12px !important",
      minWidth: "unset",
      whiteSpace: "nowrap",
      fontSize: 11,
      fontWeight: 700,
      color: `${UIKIT_COLORS.PRIMARY} !important`,
      backgroundColor: "transparent !important",
      lineHeight: "16px",
      textTransform: "none",
      "& .MuiButton-label": { fontSize: 11, fontWeight: 700 },
      "&:hover": { backgroundColor: "rgba(14, 90, 167, 0.06) !important" },
    },
    viewBtnOpen: {
      border: `1.5px solid ${UIKIT_COLORS.DANGER} !important`,
      borderRadius: 8,
      padding: "3px 12px !important",
      minWidth: "unset",
      whiteSpace: "nowrap",
      fontSize: 11,
      fontWeight: 700,
      color: `${UIKIT_COLORS.DANGER} !important`,
      backgroundColor: "transparent !important",
      lineHeight: "16px",
      textTransform: "none",
      "& .MuiButton-label": { fontSize: 11, fontWeight: 700 },
      "&:hover": { backgroundColor: "rgba(220, 38, 38, 0.06) !important" },
    },
    rejectBtn: {
      background: "none !important",
      border: "none",
      padding: "3px 4px !important",
      minWidth: "unset",
      fontSize: 11,
      fontWeight: 600,
      color: `${UIKIT_COLORS.DANGER} !important`,
      lineHeight: "16px",
      whiteSpace: "nowrap",
      textTransform: "none",
      "& .MuiButton-label": { fontSize: 11, fontWeight: 600 },
      "&:hover": { textDecoration: "underline", background: "none !important" },
    },
    closeRow: {
      textAlign: "right",
    },
    closeBtn: {
      background: "none !important",
      border: "none",
      padding: "0 4px !important",
      minWidth: "unset",
      fontSize: 14,
      fontWeight: 600,
      color: `${UIKIT_COLORS.PRIMARY} !important`,
      lineHeight: "20px",
      textTransform: "none",
      "& .MuiButton-label": { fontSize: 14, fontWeight: 600 },
      "&:hover": { textDecoration: "underline", background: "none !important" },
    },
    noImageWrap: {
      width: "100%",
      height: 329,
      backgroundColor: UIKIT_COLORS.BG_DOC,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 8,
    },
    noImageIcon: {
      fontSize: 48,
      color: UIKIT_COLORS.TEXT_MUTED,
    },
  })
);
